import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimExportElement extends IModelBase {
  Value: string
  ClaimExportSegmentId: number
  Sequence: number
  TemplateElementId: number
}

@Injectable()
export class ClaimExportElementODataService extends ODataService<IClaimExportElement> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimExportElements'
  }
}
